// Per Matrix spec (MSC1767): strip the `> <mxid> text` fallback block that
// clients bake into the body for backwards compatibility, leaving only the
// actual reply text.
//
// When replying to a reply (nested replies) the body may contain multiple
// stacked fallback blocks separated by \n\n, each still starting with "> ".
// We loop until the remaining text no longer opens with a quoted block, so
// all levels of nesting are peeled away regardless of depth.
export function stripReplyFallback(body: string): string {
  let current = body;
  for (let depth = 0; depth < 20; depth++) {
    const firstLine = current.split('\n')[0];
    if (!firstLine.startsWith('> ') && firstLine !== '>') {
      break;
    }
    const separatorIdx = current.indexOf('\n\n');
    if (separatorIdx === -1) {
      return '';
    }
    current = current.substring(separatorIdx + 2);
  }
  return current;
}
